<template>
  <b-input-group
    v-b-tooltip.hover.bottom="placeholder"
  >
    <b-input-group-text slot="prepend">
      <span class="fa fa-search"/>
    </b-input-group-text>
    <b-input
      v-model="text"
      type="text"
      :placeholder="placeholder"
      :disabled="disabled"
    />
  </b-input-group>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    value: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
